export default __webpack_public_path__ + "static/media/166.4dfc85ab.png";